module.exports = __webpack_public_path__ + "img/DIYEditor.9c2db6ce.png";